import React from 'react';
import {ImageListItem, LinearProgressWithLabel} from '../../../ui-library';
import {ChipClassName, ContainerBoxWithImages, ContainerBoxWithImagesAll, ContainerBoxWithImagesInner, CreateOutlinedIconClass, ImageListClassList, KeyboardArrowIconL, KeyboardArrowIconR, ProgressContainer} from '../Style/ClassList.style';
import {IPropsClassListWithImages} from '../Config/ClassList.types';
import useClassListWithImages from '../Controller/useClassListWithImages';
import {ImageUrl} from '../../ImageUrl';
import {NumOfImagesIcon} from '../../NewClassImages/Style/NewClassImages.style';
import {ReferenceImageUpload} from '../../ReferenceImageUpload';

const ClassListWithImages = (
    {
        numberOfSuccess,
        numberOfFiles,
        itemData,
        className,
        autoProjectState,
        activeEditId,
        activeEditClass,
        onDoneProcess,
        getChosenFiles,
        numberOfUploadFiles,
        setState,
        uiFiledFileList,
        retryAllFiledFiles,
        onDeleteFile,
        deleteClass,
        class_id
    }: IPropsClassListWithImages) => {
    const {scrollElement, scrollHorizontal, isHover, setIsHover, containerElement, setIsOpenModal} = useClassListWithImages(setState, class_id, activeEditId === class_id);
    const isShowScroll = numberOfSuccess > 6;
    const progressValue = (numberOfSuccess / numberOfFiles) * 100;

    return (
        <ContainerBoxWithImages
            inputerror={autoProjectState.activeEditId === class_id && autoProjectState.className.length === 0}
            isinhovermode={isHover}
            isineditmode={autoProjectState.activeEditId === class_id}
            ref={containerElement}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
            tabIndex={0}>
            {activeEditId === class_id ? <ReferenceImageUpload
                deleteClass={deleteClass}
                isShowTitle={false}
                isDeleteClass={true}
                getOpen={(open) => setIsOpenModal(open)}
                class_id={class_id}
                initValue={className}
                isShowBtn={false}
                retryAllFiledFiles={retryAllFiledFiles}
                numberOfFiles={numberOfUploadFiles}
                uploadCounter={numberOfSuccess}
                uiFileList={itemData}
                uiFiledFileList={uiFiledFileList}
                onDoneProcess={onDoneProcess}
                autoProjectState={autoProjectState}
                onDeleteFile={onDeleteFile}
                getChosenFiles={getChosenFiles}
                setState={setState}
                data_project_id={autoProjectState.projectId}
            />
                : <>
                    <ContainerBoxWithImagesAll>
                        <ChipClassName label={className} />
                        <ProgressContainer >
                            <NumOfImagesIcon />
                            <LinearProgressWithLabel
                                numerator={numberOfSuccess}
                                denominator={numberOfFiles}
                                value={progressValue > 100 ? 100 : progressValue}
                                width={132}
                            />
                        </ProgressContainer>
                        {isHover && <CreateOutlinedIconClass onClick={() => activeEditClass(itemData, class_id)}/>}
                    </ContainerBoxWithImagesAll>
                    {numberOfFiles > 0 && <ContainerBoxWithImagesInner>
                        {isShowScroll && <KeyboardArrowIconL
                            fontSize='large'
                            onMouseDown={() => scrollHorizontal(true)}
                        />}
                        <ImageListClassList
                            ref={scrollElement}
                            gap={7}
                            rowHeight={88}
                        >
                            {itemData.map((img) => (
                                <ImageListItem key={img.title}>
                                    <ImageUrl img={img} isAspectRatio={false} />
                                </ImageListItem>
                            ))}
                        </ImageListClassList>
                        {isShowScroll && <KeyboardArrowIconR
                            fontSize='large'
                            onMouseDown={() => scrollHorizontal(false)}
                        />}
                    </ContainerBoxWithImagesInner>}
                </>}
        </ContainerBoxWithImages>
    );
};

export default ClassListWithImages;
